import { DeleteWorkflow } from './deleteWorkflow'
import { WorkflowGates } from './workflowGate'
import { WorkflowView } from './workflowView'

const WorkflowComponents = {
  WorkflowView,
  WorkflowGates,
  DeleteWorkflow,
}

export { WorkflowComponents }
